/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  combineReducers,
  configureStore,
  isRejected,
  MiddlewareAPI,
} from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { ebookApi, externalTestApi } from '@services/api';
import reservationReducer from '@pages/Reservation/reservation.slice';
import checkinReducer from '@pages/Checkin/checkin.slice';
import checkoutReducer from '@pages/Checkout/checkout.slice';
import userReducer from '@features/Auth/user.slice';
import persistMiddleware from './persistMiddleware';
import rehydrationState from './rehydrationState';
import profileReducer from '@pages/Profile/profile.slice';
import statisticsReducer from '@pages/Statistics/statistics.slice';
import { Action, Middleware } from 'redux';

const persistConfig = {
  key: 'persistor',
  blacklist: ['auth', 'ebookApi', 'externalTestApi'],
};
const preloadedState = rehydrationState(persistConfig);

const hasStatus = (payload: any): payload is { originalStatus: number } =>
  typeof payload === 'object' &&
  payload !== null &&
  'originalStatus' in payload;

export const redirectOnForbiddenResponse: Middleware =
  (api: MiddlewareAPI) => (next) => (action) => {
    if (isRejected(action) && hasStatus(action.payload)) {
      if (
        action.payload.originalStatus === 403 &&
        window.location.pathname !== '/'
      ) {
        setTimeout(() => {
          api.dispatch({ type: 'LOGOUT' });
          sessionStorage.clear();
        }, 0);
      }
    }

    return next(action);
  };

const combinedReducer = combineReducers({
  [ebookApi.reducerPath]: ebookApi.reducer,
  [externalTestApi.reducerPath]: externalTestApi.reducer,
  reservation: reservationReducer,
  checkin: checkinReducer,
  checkout: checkoutReducer,
  user: userReducer,
  profile: profileReducer,
  statistics: statisticsReducer,
});

const reducer = (state: any, action: Action) => {
  if (action.type === 'LOGOUT') {
    state = {};
  }
  return combinedReducer(state, action);
};

export const store = configureStore({
  reducer,
  preloadedState,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      persistMiddleware(persistConfig),
      ebookApi.middleware,
      externalTestApi.middleware,
      redirectOnForbiddenResponse
    ),
});

if (process.env.NODE_ENV === 'development') {
  (window as any).store = store;
}

if (window.Cypress && process.env.NODE_ENV === 'development') {
  (window as any).store = store;
}

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
